// ====================================================
// File for small inline js plugins
//
'use strict';

// Avoid `console` errors in browsers that lack a console.
(function() {
    var method;
    var noop = function () {};
    var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeStamp', 'trace', 'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});

    while (length--) {
        method = methods[length];

        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
}());

// Place any small inline jQuery/helper plugins in here.
$(document).ready(function() {

	   // Bewertungen anlegen
	   $.each( $(".starInput"), function( k, v ) {
	      var captElemId = $(v).attr('id') + "_capt";
	      $(v).rating({
	         captionElement: "#" + captElemId,
	         defaultCaption: "{rating}",
	         clearCaption: "bitte wÃ¤hlen",
	         starCaptions: {
	             0.5: '0,5 Sterne',
	             1:   '1 Stern',
	             1.5: '1,5 Sterne',
	             2:   '2 Sterne',
	             2.5: '2,5 Sterne',
	             3:   '3 Sterne',
	             3.5: '3,5 Sterne',
	             4:   '4 Sterne',
	             4.5: '4,5 Sterne',
	             5:   '5 Sterne'
	         },
	         starCaptionClasses: {
	             0.5: '',
	             1:   '',
	             1.5: '',
	             2:   '',
	             2.5: '',
	             3:   '',
	             3.5: '',
	             4:   '',
	             4.5: '',
	             5:   ''
	         },
	         clearCaptionClass: ''
	      });
	   });

	   if ($('#reviewTitle').length) {
	      $('#reviewTitleLength').text( $('#reviewTitle').val().length );
	      $('#reviewTitle').keyup(function (e) {
	          $('#reviewTitleLength').text( $('#reviewTitle').val().length );
	      });

	      $('#reviewTextLength').text( $('#reviewText').val().length );
	      $('#reviewText').keyup(function (e) {
	          $('#reviewTextLength').text( $('#reviewText').val().length );
	      });
	   }


	   // Neuen Anbieter registrieren
	   $("input[type=radio][name=registerUser]").change(function() {
	        if (this.value == "N") {
	           $("#compData").show("slow");
	           $("#submitDiv").show("slow");
	           $("#persData").hide("slow");
	        }
	        else if (this.value == "Y") {
	           $("#persData").show("slow");
	        }
	    });

	});
